import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import "../node_modules/uikit/dist/css/uikit.min.css";
import "./index.css";

UIkit.use(Icons);
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// reportWebVitals();
